window.Payout = {

    translations: {
        deposit: Loc.g("Versement"),

    },
    displayDetails: function (payoutId, partner, transactionId) {

        var self = this;
        var options = {
            dialogClass: "",
            title: self.translations.deposit,
            width: 900,
            buttons: [
                {
                    text: Loc.g("Fermer"), click: function () {
                        $(this).dialog("close");
                    }
                }
            ]
        };

        var param = {
            action: "displayDetails",
            payoutId: payoutId,
            partner: partner,
            transactionId: transactionId,
        };

        MyWindow.load('payout', param, options);


    },

}
